import React from 'react';
import {
  useAtom as useStateSegment,
  useSetAtom as useStateSegmentSetter,
} from 'jotai';
import {
  closePopoverStateSegment,
  popoverStateSegment,
} from '../../../store/markettingContentGeneration/stateSegments/popoverStateSegment';
import Popover from '../../atoms/Popover';

const PopoverContainer: React.FC<{
  children: React.ReactElement;
  className?: string;
  style?: React.CSSProperties;
  visible?: boolean;
  customIcon?: React.ReactNode;
  usePortal?: boolean;
}> = ({
  children,
  className,
  style,
  visible = true,
  customIcon,
  usePortal = false,
}) => {
  const [popoverState] = useStateSegment(popoverStateSegment);
  const closePopover = useStateSegmentSetter(closePopoverStateSegment);

  if (!popoverState.showPopover) return children;

  return (
    <Popover
      isOpen={popoverState.showPopover && visible}
      onClose={closePopover}
      variant={popoverState.variant}
      arrowPosition={popoverState.arrowPosition}
      title={popoverState.title}
      description={popoverState.description}
      buttonLabel={popoverState.buttonLabel}
      onButtonClick={popoverState.onButtonClick}
      showCloseButton={popoverState.showCloseButton}
      showIcon={popoverState.showIcon}
      className={className}
      style={style}
      customIcon={customIcon}
      usePortal={usePortal}
    >
      {children}
    </Popover>
  );
};

export default PopoverContainer;
